export default "__VITE_ASSET__dxATHJws__"